module.exports = __webpack_public_path__ + "img/statistics-no-data.be366702.png";